jQuery(document).ready(function(){

  var sliderHomeHero = jQuery('.cms-home .cms-home-slider');
  sliderHomeHero.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  });

  // BestSellers Slider
  var slickGrid = jQuery('.cms-home .best-seller-grid');
  slickGrid.slick({
    dots:true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          dots:true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false
        }
      },
      {
        breakpoint: 600,
        settings: 'unslick'
      }
    ]
  });


  // more cute looks on product page slider

  var card = jQuery('.box-up-sell .products-grid');
  card.slick({
    responsive: [
      {
        breakpoint: 9999,
        settings: {
          slidesToShow: 6,
          dots:false,
          arrows:false
        }
      },
      {
        breakpoint: 599,
        settings: {
          arrows: false,
          dots: true,
          variableWidth: true,
          infinite: false
        }
      }
    ]
  });

  jQuery('.catalog-product-view .fancybox').on('click', function(e){
    e.preventDefault();
    jQuery('#notify-size').addClass('active');
  });
  jQuery('#notify-size .close-link').on('click', function(){
    jQuery('#notify-size').removeClass('active');
  });

  // Show minicart when an item is added, don't display success-msg
  if (jQuery('.catalog-product-view .success-msg').length){
    jQuery('#header-cart').addClass('skip-active');
    setTimeout(function() {
      jQuery('#header-cart').removeClass('skip-active');
    }, 5000)
  };

  /*jQuery('.skip-search').click(function(e) {
        e.preventDefault();
        jQuery('#header-search').toggleClass('skip-active');
    });

	jQuery('.skip-nav').click(function(e) {
        e.preventDefault();
        jQuery('#header-nav').toggleClass('skip-active');
    });*/

  var loadSwinxyProductpage = function() {

    // more views on product page slider
    //         var slickGrid = jQuery('.product-img-box ul.product-image-thumbs');

    //         slickGrid.slick({
    //             dots:false,
    //             vertical: true,
    //             arrows: true,
    //             slidesToShow: 4,
    //             responsive: [
    //                 {
    //                     breakpoint: 768,
    //                     settings: {
    //                         slidesToShow: 1,
    //                         slidesToScroll: 1,
    //                         dots:true,
    //                         arrows:false
    //                     }
    //                 }
    //             ]
    //         });




    $(function () {
      var win = $(window);


      win.on("load resize", function () {
        var slickGrid = jQuery('.product-img-box ul.product-image-thumbs');
        if (win.width() < 768) {


          slickGrid.slick({
            dots:false,
            arrows: true,
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots:true,
                  arrows:false
                }
              }
            ]
          });
        } else if (slickGrid.hasClass("slick-initialized")) {
          slickGrid.slick("unslick");
        }
      });
    });

    //Swinxy zoom and swap images on product page
    jQuery('a.swinxyzoom').swinxyzoom({
      mode: 'window',
      size: '100%',
      controls: false
    });

    jQuery(document).on('click', '.more-views a', function(e){
      e.preventDefault();
      var $this = jQuery(this);
      var path = $this.attr('href');

      //load thumbnail into main image
      jQuery('.swinxyzoom').swinxyzoom('load', path , path);

      //Change which thumbnail is active
      jQuery('.more-views a').removeClass('swinxy-active');
      jQuery(this).addClass('swinxy-active');

      //Update the open in new tab link with current image path
      jQuery('.icon-external-link').attr('href', path);

    });


    var imagePopupFunction = function(imageSrc){
      if ($(window).width() > 767) {
        $('.popup-image').magnificPopup({
          items: {
            src: imageSrc
          },
          type: 'image' // this is default type
        });
      }
    };
    var imageSrc = $(document).find('.main-image').attr('src');

    imagePopupFunction(imageSrc);

    $('.image-popup').magnificPopup({type:'image',closeOnContentClick: true});
    $('.product-video-thumb-desktop').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });

    slickGrid.on('click', '.slick-slide', function(){
      imageSrc = $(document).find('.main-image').attr('src');
      imagePopupFunction(imageSrc);
    });

    //imagePopupFunction(imageThumbSrc);

  };

  loadSwinxyProductpage();

  jQuery(window).on('resize', function(){
    loadSwinxyProductpage();
  });

  /*
    jQuery(window).on('resize', function(){
		loadSwinxyProductpage();
	}).trigger('resize');
  */


  // Accordion Menu in Mobile Footer
  var footerLink = jQuery('.footer-bottom .block-title');

  footerLink.on('click', function(){
    //if the category is not open

    if(!jQuery(this).hasClass('active')){
      //close all other
      footerLink.removeClass('active');
      jQuery('.content').removeClass('active');

      // Add Plus sign to this one
      jQuery(this).addClass('active');
      //open the category
      jQuery(this).siblings('.content').addClass('active');
    }
    else{
      //if it is open close it
      jQuery(this).removeClass('active');
      jQuery('.content').removeClass('active');
    };
  });

  // Accordion Menu in Mobile Header and Homeapge
  var navLinks = jQuery('#nav .level-top.parent > a');

  navLinks.on('click', function(e){
    var windowSize = jQuery(window).width();

    //if this category is closed
    if(!jQuery(this).siblings('.drop').hasClass('active') && windowSize <= 900){
      e.preventDefault();
      jQuery('ul.drop').removeClass('active');
      navLinks.removeClass('active');
      jQuery(this).siblings('.drop').addClass('active');
      jQuery(this).addClass('active');
    }
    else if(jQuery(this).siblings('.drop').hasClass('active') && windowSize <= 900){
      e.preventDefault();
      jQuery('ul.drop').removeClass('active');
      jQuery(this).removeClass('active');
    }
  });

  // Filters on Desktop Listing Page
  jQuery(".layerDropdown").on('click', function() {
    jQuery(this).parent().toggleClass("active");
  });

  // Shopping Cart
  jQuery('.cart-forms .toggleContainer').on('click', function(e){
    e.preventDefault();
    jQuery(this).toggleClass('active').siblings().children('.field-wrapper').toggleClass('active')
  });

  jQuery('.shipping-link').on('click', function(e){
    e.preventDefault();
    jQuery('.shipping .field-wrapper').toggleClass('active');
  });


  // Product sticky section
  $('.product-view .product-shop').stickybits({
    useStickyClasses: true,
    stickyBitStickyOffset: 160
  });
  
  // Collection grid video thumbnail height
  var thumbnailVideoHeightFunction = function() {
    var thumbnailImage = $('.products-grid .product-image .lazyloaded');
    
    if(thumbnailImage.length > 0) {
      var thumbnailImageHeight = thumbnailImage.outerHeight();

      console.log(thumbnailImageHeight);
      if(thumbnailImageHeight > 0) {
        $('.products-grid .product-image video').css({
          height: thumbnailImageHeight
        });
      } else {
        thumbnailVideoHeightFunction();
      }
    } else {
      setTimeout(function() {
        thumbnailVideoHeightFunction();
      }, 100);
    }
  }
  
  $(window).on("load resize orientationchange", function () {
    thumbnailVideoHeightFunction();
  });
  
});